<template>
    <div class="form-group row" v-if="this.form_type == 'search'">
        <label for="email" class="col-md-2 col-form-label text-md-right">{{ form_label }}</label>
        <div class="col-md-10">
            <v-select multiple :options="options" label="name" v-model="selected" @input="inputs" />
        </div>
        <input v-for="tag in tags" type="hidden" :name="form_attribute" :value="tag.id" />

    </div>
    <div class="form-group" v-else>
        <label for="email" >{{ __('Tag') }}<span class="text-danger">{{ __('Required') }}</span></label>
        <v-select multiple :options="options" label="name" v-model="selected" @input="inputs" />
        <input v-for="tag in tags" type="hidden" :name="form_attribute" :value="tag.id" />

    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import axios from 'axios';

Vue.component('v-select', vSelect);

export default {
    name: "TagAutoInputComponent",
    props: ['default', 'type', 'stype', 'label', 'attribute_name'],
    data () {
        return {
           selected: this.default,
           form_type: this.type || 'search',
           form_label: this.label || 'タグ検索',
           form_attribute: ( this.attribute_name ) ? this.attribute_name + '_tags[]' : 'tags[]',
           options: [],
           tags: this.default
        }
    },
    mounted() {
        console.log('Component mounted.');
    },
    methods: {
        inputs (val) {
            console.log(val);
            this.tags = val;
        }
    },
    async created () {
        console.log('created');
        console.log(this.default);
        const  qs = (this.stype) ? '?type=' + this.stype : '';
        const response = await axios.get('/api/tags' + qs);
        this.options = response.data;
    }
}
</script>
